module.exports = __webpack_public_path__ + "static/2-d8af53b7d9277c0b11d331054db32a56.jpg";